module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"unlil":"until","show":"View","update":"Edit","delete":"Delete","allVacanciesArchived":"All jobs in this selection have been archived","emptyVacancies":"There are no jobs in this selection","filterTitle":"Jobs selection","filter.all":"All jobs","filter.address":"By address","filter.list":"Hand-pick jobs","allVacancies":"All jobs"}}')
  delete Component.options._Ctor
}
